import { Component, OnInit } from '@angular/core';
import { AlertService, ComponentsStoreService, IAlertType } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { Components } from '../../../_shared/interfaces';
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ClarityIcons, cogIcon, nodeIcon, twoWayArrowsIcon} from "@cds/core/icon";
import { ComponentSubnavComponent } from "../component-subnav/component-subnav.component";

@Component({
  selector: 'app-component-technology',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    ClrIconModule,
    NgIf,
    ComponentSubnavComponent
  ],
  templateUrl: './component-technology.component.html',
  styleUrl: './component-technology.component.sass'
})
export class ComponentTechnologyComponent implements OnInit {
  technologies: Components[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  constructor(
    private compss: ComponentsStoreService,
    public alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, nodeIcon, cogIcon);
  }

  ngOnInit(): void {
    this.loading = true;
    this.getTechnologies();
  }

  private getTechnologies() {
    this.compss.getTechnologies().subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Verfahren gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.technologies = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }
}
